(function AskMaxxHistory($, Adzuki)
{
	"use strict";

	var $modal  = $('.modal');

	$(document).ready(function documentReady()
	{
		Adzuki.onload('Ai/askMaxxHistory', function onload() {
			$('.ask-maxx-history').on('click', function onClick(e) {
				var conversationId    = $(this).data('id'),
					conversationTitle = $(this).data('title'),
					searchTerm        = $(this).data('search-term');

				e.preventDefault();

				$modal.find('.modal-title').text(conversationTitle);
				Adzuki.Ajax.get('/Ai/askMaxxHistoryDetails/' + conversationId + '/' + searchTerm).then(function success(html) {
					$modal.find('.modal-body').html(html);
				});

				$modal
					.addClass('history-modal') // Add a class to adjust width
					.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('history-modal').removeClass('wide').off('hidden.bs.modal');
					})
					.on('shown.bs.modal', function _adjustModalHeight() {
						setModalMaxHeight();
					})
					.modal('show');

				// Call setModalMaxHeight on window resize
				$(window).on('resize', setModalMaxHeight);
			});

			$modal.on('click', '.history-copy', function onClick(e) {
				var replyId = $(this).data('chatbot-reply-id');
				var $replyMessage = $modal.find('.history-chatbot-bot-reply-message[data-chatbot-reply-id="' + replyId + '"]');
				var responseText = $replyMessage.html();

				// Check if $replyMessage is valid and has content
				if ($replyMessage.length === 0 || !responseText) {
					console.error('Invalid object or empty response');
					Adzuki.StatusMessage('Error', 'Failed to copy response to clipboard');
					return;
				}

				// Replace <br> tags with new lines and trim
				responseText = responseText.replace(/<br\s*\/?>/gi, '\n').trim();

				copyToClipboard(responseText);
			});

			$modal.on('click', '.history-chatbot-references', function _clickReferences(e) {	
				// Find the toggle button within the clicked element
				var $toggle = $(this).find('.chatbot-reference-toggle'),
					$wrapper,
					$content;

				e.preventDefault();
				e.stopPropagation(); // Stop the event from bubbling up
				
				// Toggle the classes manually
				$toggle.toggleClass('fa-chevron-right fa-chevron-down');

				// Find the content and wrapper
				$wrapper = $(this).closest('.history-chatbot-references-wrapper');
				$content = $wrapper.find('.history-chatbot-references-content');

				// Toggle the content visibility
				if ($toggle.hasClass('fa-chevron-down')) {
					$content.slideDown(300);
					$wrapper.css('max-height', 'none');
				} else {
					$content.slideUp(300, function _collapse() {
						$wrapper.css('max-height', '');
					});
				}
			});
		});
	});

	function copyToClipboard(text) {
		// Create a temporary element
		var tempElement = document.createElement('div');
		var range;
		var selection;

		tempElement.innerHTML = text;
		tempElement.setAttribute('style', 'position: absolute; left: -9999px;');
		document.body.appendChild(tempElement);

		// Select the text
		range = document.createRange();
		range.selectNodeContents(tempElement);
		selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange(range);

		// Try to copy
		try {
			if (document.execCommand('copy')) {
				Adzuki.StatusMessage('Success', 'Response copied to clipboard');
			} else {
				throw new Error('Copy command failed');
			}
		} catch (err) {
			console.error('execCommand Error:', err);

			// Fallback to Clipboard API
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(text).then(function _writeText() {
					Adzuki.StatusMessage('Success', 'Response copied to clipboard');
				}).catch(function _clipboardError(clipboardErr) {
					console.error('Clipboard API Error:', clipboardErr);
					Adzuki.StatusMessage('Error', 'Failed to copy response to clipboard');
				});
			} else {
				Adzuki.StatusMessage('Error', 'Failed to copy response to clipboard');
			}
		} finally {
			// Clean up
			selection.removeAllRanges();
			document.body.removeChild(tempElement);
		}
	}

	function setModalMaxHeight() {
		var windowHeight = $(window).height();
		var modalHeader = $modal.find('.modal-header').outerHeight() || 0;
		var modalFooter = $modal.find('.modal-footer').outerHeight() || 0;
		var modalBodyPadding = parseInt($modal.find('.modal-body').css('padding-top'), 10)
								+ parseInt($modal.find('.modal-body').css('padding-bottom'), 10);

		var maxHeight = windowHeight - modalHeader - modalFooter - modalBodyPadding - 60; // 20px for some margin
		$modal.find('.modal-body').css('max-height', maxHeight + 'px');
	}

}(jQuery, window.Adzuki || {}));